import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button/Button";
import { getLoadErrorMessage } from "@/utils/errorUtils";

export interface LoadErrorPanelProps {
  title?: string;
  error: unknown;
  onRetry?: () => void;
  className?: string;
  "data-testid"?: string;
}

/**
 * Dark-mode-friendly load failure panel for surfaces and dashboards.
 */
export function LoadErrorPanel({
  title = "Couldn't load content",
  error,
  onRetry,
  className,
  "data-testid": dataTestId = "load-error-panel",
}: LoadErrorPanelProps) {
  const message = getLoadErrorMessage(error);

  return (
    <div className={className ?? "p-6"} data-testid={dataTestId}>
      <Alert variant="error" borderless className="space-y-3">
        <p className="font-medium">{title}</p>
        <p className="text-sm opacity-90">{message}</p>
        {onRetry ? (
          <Button outline onClick={onRetry} data-testid={`${dataTestId}-retry`}>
            Try again
          </Button>
        ) : null}
      </Alert>
    </div>
  );
}
